jQuery(function ($) {
    $('.toggle-next-ul').on(oEventNames.end, function (event) {
        if (!bIsScrolling) {
            event.preventDefault();
            var oClickedLink = $(this);
            $(this).closest('.tab-heading-slide').next('.lists').stop().slideToggle(function () {
                if ($(this).css('display') == 'block') {
                    oClickedLink.find('.toggle-mark').text('－');
                } else {
                    oClickedLink.find('.toggle-mark').text('＋');
                }
            });
        }
    });
});

/*==================================================
ページ内リンク
==================================================*/

$(function () {
    var headerHight = 200; //ヘッダの高さ
    $('.search-result-list-box a[href^="#"], .tab-list-company a[href^="#"]').on("click", function (event) {
    event.preventDefault();
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    var position = target.offset().top - headerHight; //ヘッダの高さ分位置をずらす
    $("html, body").animate({ scrollTop: position }, 400, "swing");
    });
});
